import { render } from "./SuspendBuybackModal.vue?vue&type=template&id=cf9ed9de&scoped=true&ts=true&lang=pug"
import script from "./SuspendBuybackModal.vue?vue&type=script&lang=ts"
export * from "./SuspendBuybackModal.vue?vue&type=script&lang=ts"

import "./SuspendBuybackModal.vue?vue&type=style&index=0&id=cf9ed9de&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9ed9de"]])

export default __exports__